import React from 'react';
import VerfiySection from '../Components/Verify';

const VerifyPage = () => (
  <VerfiySection />
);

export default VerifyPage;
